import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import Checkbox from '../../../../components/Checkbox/Index';
import DropDown from '../../../../components/DropDown/DropDown';
import KebabIcon from '../../../../assets/svg/icons/common/kebab';
import WarningIcon from '../../../../assets/svg/icons/common/Warning';
import RiskIcon from '../../../../assets/svg/icons/common/risk';
import ConfirmationModal from '../../../application/components/ConfirmationModal/ConfirmationModal';
import { RemoveMcc } from '../../../../../api';
import toast from 'react-hot-toast';
import useMccStore from '../../../../stores/mcc';

const MCCCard = ({ data, fetchData }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const isMountedRef = useRef(true);

  const setRecordToEdit = useMccStore((state) => state.setRecordToEdit);
  const setIsAddMCCModalOpen = useMccStore((state) => state.setIsAddMCCModalOpen);
  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const dropDownOptions = [
    {
      text: "Edit",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data);
        setIsAddMCCModalOpen(true);
      },
    },
    {
      text: "Delete Code",
      type: "danger",
      onClick: () => {
        setDeleteModal(true);
      },
    },
  ];

  const deleteMcc = async () => {
    const toastId = toast.loading('Deleting...');
    const response = await RemoveMcc(data?.id);
    if (response?.success) {
      toast.success("Deleted successfully", { id: toastId, duration: 5000 });
      if (isMountedRef.current && fetchData) fetchData();
      setDeleteModal(false);
    } else {
      toast.error("Failed to delete MCC code", { id: toastId, duration: 5000 });
      setDeleteModal(false);
    }
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedMcc([...selectedMcc, +value]);
    } else {
      setSelectedMcc(selectedMcc.filter((id) => id !== +value));
    }
  };

  const riskLabel = data.risk ? data.risk.split("_")?.[0] : null;
  const riskDisplay = riskLabel ? riskLabel.charAt(0).toUpperCase() + riskLabel.slice(1) : "-";

  return (
    <>
      <div className={styles.mobile_card}>
        <div className={styles.mobile_card_top_row}>
          <div className={styles.mobile_card_meta}>
            <div className={styles.mobile_card_checkbox}>
              <Checkbox
                checked={selectedMcc.includes(data.id)}
                value={data.id}
                onChange={handleCheckboxChange}
              />
            </div>
            <div className={styles.mobile_card_id_mcc}>
              <span className={styles.mobile_card_id}>ID: {data?.id}</span>
              <span className={styles.mobile_card_separator} />
              <span className={styles.mobile_card_mcc}>MCC: {data?.mcc}</span>
            </div>
          </div>
          <div className={styles.mobile_card_actions}>
            <div className={styles.mobile_card_risk}>
              {data.risk ? (
                <>
                  {data.risk === "high_risk" ? (
                    <WarningIcon />
                  ) : (
                    <RiskIcon />
                  )}
                  <span className={styles.risk_text}>{riskDisplay}</span>
                </>
              ) : (
                <span className={styles.risk_text}>{riskDisplay}</span>
              )}
            </div>
            <div className={styles.mobile_card_kebab}>
              <DropDown options={dropDownOptions}>
                <KebabIcon />
              </DropDown>
            </div>
          </div>
        </div>
        <div className={styles.mobile_card_content}>
          <div className={styles.mobile_card_category}>{data?.category}</div>
          {data?.description && (
            <div className={styles.mobile_card_description}>{data.description}</div>
          )}
        </div>
      </div>

      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          onClose={() => {
            setDeleteModal(false);
          }}
          message={"Are you sure you want to delete selected mcc code? You can't undo this action."}
          onConfirmClick={deleteMcc}
        />
      )}
    </>
  );
};

export default MCCCard;
